import React, { useRef } from "react";
import onboarding3 from "../../images/Onboarding-1.jpg";
import onboarding2 from "../../images/onboarding-2.jpg";
import onboarding1 from "../../images/onboarding-3.jpg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { useHistory } from "react-router-dom";

const SampleNext = (props) => {
  const { className, title, slider, lastSlide } = props;

  const history = useHistory();

  const handleClick = () => {
    if (lastSlide) {
      history.push("/signup");
    } else {
      slider.current.slickNext();
    }
  };

  return (
    <button className={className} onClick={handleClick}>
      {title}
    </button>
  );
};

const OnBoarding = () => {
  const slider = useRef(null);

  const history = useHistory();

  const handleSkip = () => {
    history.push("/signup");
  };

  var welcomeslider = {
    dots: true,
    nav: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,

    //nextArrow: <SampleNext title="Next" slider={slider} counter={counter} addSlideCounter={addSlideCounter} />,
    responsive: [
      {
        breakpoint: 9999,
      },
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className="onboarding">
      <div className="loginsidebar-inner">
        <Slider className="welcome-block" {...welcomeslider} ref={slider}>
          <div className="item">
            <div className="login-img">
              <img src={onboarding1} alt="welcome" />
            </div>
            <div className="item-content">
              <div className="skip-btn">
                <button onClick={handleSkip}>Skip for now </button>
              </div>
              <h2>Showcase your business</h2>
              <p>
                {" "}
                Get your business in front of customers and
                let them know what products and services you offer.{" "}
              </p>
              <div className="next-btn">
                <SampleNext
                  title="Next"
                  slider={slider}
                  className="slick-next"
                />
              </div>
            </div>
          </div>
          <div className="item">
            <div className="login-img">
              <img src={onboarding2} alt="welcome" />
            </div>
            <div className="item-content">
              <div className="skip-btn">
                <button onClick={handleSkip}>Skip for now </button>
              </div>
              <h2>Create exclusive deals and promotions</h2>
              <p>
              Drive store traffic through exclusive deals and let them be the 
              first to know when your store is running a promotion.{" "}
              </p>
              <div className="next-btn">
                <SampleNext
                  title="Next"
                  slider={slider}
                  className="slick-next"
                />
              </div>
            </div>
          </div>
          <div className="item">
            <div className="login-img">
              <img src={onboarding3} alt="welcome" />
            </div>
            <div className="item-content">
              <div className="skip-btn">
                <button onClick={handleSkip}>Skip for now </button>
              </div>
              <h2>
                Interact with your customers
              </h2>
              <p>
              Keep your customers engaged with ongoing deals that you can 
              change 24/7{" "}
              </p>
              <div className="next-btn">
                <SampleNext
                  title="Get Started"
                  slider={slider}
                  className="slick-next"
                  lastSlide
                />
              </div>
            </div>
          </div>
        </Slider>
      </div>
    </div>
  );
};

export default OnBoarding;
